<template lang="html">
  <div id="d-benefits-page">

    <!-- <section class="search-section-s1">
      <b-form @submit="onSubmit">
        <b-form-group class="form-group-s1">
          <b-form-input
          v-model="formSearch.keywords"
          type="text"
          placeholder="Buscar..."
          required
          ></b-form-input>
        </b-form-group>
        <b-button type="submit" class="btn-search">
          <i class="far fa-search"></i>
        </b-button>
      </b-form>
    </section> -->

    <section class="results-section" v-if="!loading">
      <b-card no-body>
        <b-tabs card>

          <!-- Restaurantes -->
          <b-tab :title="c.name" active v-for="(c, cInx) in benefits" :key="'cat'+cInx">
            <b-card-text>
              <router-link class="post-template-s3"
                v-for="(b, bInx) in c.benefits"
                :key="'bInx-'+bInx" 
                :to="{ name: 'accBeneDetallePage', params: { id: b.id } }">
                <div class="col placed-backg box-image" v-bind:style="{ backgroundImage: 'url('+b.imageUrl+')' }" style="background-size: contain;"></div>

                <div class="col box-text">
                  <h5 class="title">{{ b.name }}</h5>
                 
                  <div class="descr">
                    <p>{{ b.description }}</p>
                  </div>

                  <hr />

                  <p>
                    <span class="btn-more">Ver detalle</span>
                  </p>
                </div>
              </router-link>
            </b-card-text>
          </b-tab>
          <!--  -->

   
        </b-tabs>
      </b-card>
    </section>
    <section class="results-section" v-else>
        <div class="box-results" style="padding-top: 150px;text-align: center;">
                <div class="fa-5x"><i class="fas fa-spinner fa-pulse"></i></div><br>
                
        </div>
    </section>

  </div>
</template>

<script>
export default {
  data() {
    return {
      formSearch: {
        keywords: null
      },

      results: [
        { imageUrl: 'public/images/pages/account/beneficios/image-1.jpg', title: 'Wings Army 2x1', subtitle: 'Todos los Jueves, Alitas al 2x1, mostrando tu credencial.' },
        { imageUrl: 'public/images/pages/account/beneficios/image-2.jpg', title: 'Café Americano Gratis', subtitle: 'A partir de las 11:00am en la compra de cualquier producto.' },
      ],
      benefits:[],
      loading:false,
    }
  },

  methods: {
    onSubmit(event) {
      event.preventDefault();
    },
    getRows(){
      this.loading = true;
      axios.get(tools.url("/api/benefits")).then((response)=>{
          this.benefits = response.data;
          this.loading = false;
      }).catch(()=>{
        this.loading = false;
      });
    }
  },
  mounted(){
      this.getRows();
  }
}
</script>
